import { render, staticRenderFns } from "./patrolDetails.vue?vue&type=template&id=370f7d24&scoped=true&"
import script from "./patrolDetails.vue?vue&type=script&lang=js&"
export * from "./patrolDetails.vue?vue&type=script&lang=js&"
import style0 from "./patrolDetails.vue?vue&type=style&index=0&id=370f7d24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370f7d24",
  null
  
)

export default component.exports